import { useMemo } from 'react';
import { LOG_ACTIONS, logAction } from '@namespace/analytics';
import { useBetSlip } from '@namespace/betslip';
import { useOutcomeCalculation } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { useOutcomeCoefChange } from '../../hooks/useOutcomeCoefChange';
import { useEventFields } from '../../store';
import { useOutcome } from '../../store/selectors/outcome';
import { OutcomeButton } from '../OutcomeButton';

const minVisibleCoef = 1.01;

export const OutcomeButtonContainer = ({
  outcomeId,
  outcomeTypeId,
  market,
  eventId,
  isShowName,
  isShowShortName,
  lineView,
  amplitudeEntryPoint,
  increasedOdds
}) => {
  const outcome = useOutcome(outcomeId);
  const { outcomeVisible, outcomeName, outcomeShortName } = outcome;

  const name = useMemo(() => {
    if (isShowName) {
      return outcomeName;
    }
    if (isShowShortName) {
      return outcomeShortName;
    }
    return null;
  }, [isShowName, isShowShortName, outcomeShortName, outcomeName]);

  const { marketSuspend, marketId } = market;
  const { placeBet, isSelected, coef } = useBetSlip(outcome, market);
  const outcomeChange = useOutcomeCoefChange(coef);
  const isShowOutcome =
    !marketSuspend && outcomeVisible && Number(coef) >= minVisibleCoef;
  const { isDesktopDevice } = useDeviceStore();
  const outcomeCalculation = useOutcomeCalculation();
  const coefficient = outcomeCalculation(coef);
  const { sportId, sportName, eventName } = useEventFields({
    eventId,
    fields: ['sportId', 'sportName', 'eventName']
  });

  const handleBetClick = () => {
    logAction(LOG_ACTIONS.SELECTED_OUTCOME, {
      matchId: eventId,
      outcome: coef,
      marketId,
      outcomeId,
      isSelected
    });
    placeBet({ sportId, sportName, eventName, coef, amplitudeEntryPoint });
  };

  return (
    <OutcomeButton
      coefficient={coefficient}
      name={name}
      isShowOutcome={isShowOutcome}
      increasedOdds={increasedOdds}
      outcomeChange={outcomeChange}
      onClick={handleBetClick}
      isSelected={isSelected}
      isDesktopDevice={isDesktopDevice}
      lineView={lineView}
      outcomeTypeId={outcomeTypeId}
      eventId={eventId}
    />
  );
};
